import { useEffect, useState } from "react";
import { MonitorSmartphone } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";

export function DevicesCard() {
  const [data, setData] = useState(null);
  const load = () => api.get("/auth/sessions").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return null;

  const end = async (sid) => {
    try { await api.delete(`/auth/sessions/${sid}`); toast.success("Device signed out"); load(); } catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div data-testid="devices-card" className="mt-6 rounded-3xl bg-[#151C2C] border border-[#26334D] p-8">
      <h2 className="text-base md:text-lg font-bold flex items-center gap-2">
        <MonitorSmartphone className="h-4 w-4 text-[#00E5A3]" /> Signed-in devices
        <span data-testid="devices-count" className="ml-auto text-sm font-normal text-slate-400">{data.sessions.length}{data.limit ? ` of ${data.limit}` : ""}</span>
      </h2>
      <div className="mt-4 space-y-2">
        {data.sessions.map((s) => (
          <div key={s.sid} data-testid={`account-device-${s.sid}`} className="flex items-center gap-3 rounded-xl bg-[#0B0F19] border border-[#26334D] p-3 text-sm">
            <span className="flex-1 truncate">{s.device} {s.current && <span className="text-xs text-[#00E5A3] ml-1">· This device</span>}</span>
            {!s.current && (
              <Button data-testid={`account-device-signout-${s.sid}`} onClick={() => end(s.sid)} variant="outline"
                className="h-8 rounded-full border-[#26334D] bg-transparent hover:bg-[#1E293B] text-xs">Sign out</Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
